/* eslint-disable no-confusing-arrow */

import styled from 'styled-components';
import { MAX_SM, MIN_MD, theme } from '../../theme';

export const TrainWrapper = styled.div`
  display: flex;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
`;

export const CarriageWrapper = styled.div`
  margin-right: 5px;
  flex: 1;
  &:first-child {
   margin-left: 5px;
  }
`;

export const CarriageName = styled.div`
  color: ${theme.colors.w10_darkgreen};
  font-size: 10px;
  text-align: center;
`;

export const IconWrapper = styled.div`
  width: 68px;
`;

export const CoachInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 11px 0;
  h1 {
   margin: 0;
   font-size: 10px;
   font-weight: 300;
  }
`;

export const StarRectangleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  min-width: 12px;
  width: ${({ width }) => `${width}px` || '12px'};
  margin: 0 4px;
  border-radius: 1px;
  background-color: ${theme.colors.w10_darkgreen};
`;

export const TrainMapWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TrainMapScrollContainer = styled.div`
  @media screen and (max-width: ${MAX_SM}) {
    max-width: ${({ maxWidth }) => maxWidth ?? '100vw'};
     overflow-y: scroll;
       .train-map {
         min-width: 1000px;
       }
   }

   ::-webkit-scrollbar {
     display: none;
    }
   scrollbar-width: none;
`;

export const StyledChevron = styled.div`
  position: absolute;
  top: ${({ isDoubleDecker }) => isDoubleDecker ? '9px' : '1px'};
  width: 24px;
  height: 24px;
  background-color: ${theme.colors.w80_silver};
  opacity: 0.9;
  cursor: pointer;
  svg {
    path {
      stroke: ${theme.colors.brand_green};
    }
  }
  &.right {
    right: 0;
   }
  &.disabled {
    pointer-events: none;
    svg {
      path {
        stroke: ${theme.colors.light90};
      }
    }
  }

  @media screen and (min-width: ${MIN_MD}) {
    display: none;
  }
`;
